import React from 'react'
import './Styles/Github.css';

const Github = () => {
    return (
        <>
            <div className='github_div' id='Skills1' data-aos="fade-up">
                <h2 className='github_title'> Github Contributions<span className='prof'> in 2025</span></h2>
                <img src="https://ghchart.rshah.org/ajinkyaspatil20" className='github_img' alt="ajinkyaspatil20's Github chart" />
                <p className='github_total'>My GitHub Contributions</p>
            </div>
        </>
    )
}

export default Github